import { TileLayer } from '@deck.gl/geo-layers';

import { TILE_CDN } from '../../config';

import { renderBitmapTileSubLayer } from './renderBitmapTileSubLayer';

export const aerialYears = {
  cuzkBase:
    'https://ags.cuzk.cz/arcgis1/rest/services/ZTM_WM/MapServer/tile/{z}/{y}/{x}?blankTile=false',
  zbgisSR:
    'https://zbgis.skgeodesy.sk/zbgis/rest/services/ZBGIS/MapServer/tile/{z}/{y}/{x}?blankTile=false',
  zbgisSROrto:
    'https://zbgis.skgeodesy.sk/zbgis/rest/services/Ortofoto/MapServer/tile/{z}/{y}/{x}?blankTile=false',
  touristSR: `${TILE_CDN}/freemap/{z}/{x}/{y}@2x`,
  cuzk2023:
    'https://ags.cuzk.cz/arcgis1/rest/services/ORTOFOTO_WM/MapServer/tile/{z}/{y}/{x}',
  cuzkLMS:
    'https://ags.cuzk.cz/arcgis4/rest/services/Archiv/lms_spojene_ortofotomapa_historicka/MapServer/tile/{z}/{y}/{x}?blankTile=false',
  mapySparse:
    'https://api.mapy.cz/v1/maptiles/names-overlay/256/{z}/{x}/{y}?apikey=neSi5SXVsQZJU-vVZ22E8r5IP_HTW_P-jLf5HkUqCzQ',
  mapy2023:
    'https://api.mapy.cz/v1/maptiles/aerial/256/{z}/{x}/{y}?apikey=neSi5SXVsQZJU-vVZ22E8r5IP_HTW_P-jLf5HkUqCzQ',
  // mapy2021: 'https://mapserver.mapy.cz/ophoto1921/{z}-{x}-{y}', (DISABLED BY CORS AT MAPY.CZ)
  mapy2018:
    'https://mapserver.mapy.cz/ophoto1618-m/{z}-{x}-{y}?sdk=HgUbCgUbGkgqAQkYBxYEHQNHQlJfR1xdSl1fQQ%3D%3D',
  mapy2015:
    'https://mapserver.mapy.cz/ophoto1415-m/{z}-{x}-{y}?sdk=HgUbCgUbGkgqAQkYBxYEHQNHQlJfR1xdSl1fQQ%3D%3D',
  mapy2012:
    'https://mapserver.mapy.cz/ophoto1012-m/{z}-{x}-{y}?sdk=HgUbCgUbGkgqAQkYBxYEHQNHQlJfR1xdSl1fQQ%3D%3D',
  mapy2003:
    'https://mapserver.mapy.cz/ophoto0203-m/{z}-{x}-{y}?sdk=HgUbCgUbGkgqAQkYBxYEHQNHQlJfR1xdSl1fQQ%3D%3D',
  tomTom:
    'https://api.tomtom.com/map/1/tile/sat/main/{z}/{x}/{y}.jpg?key=0OAizyIdeTJzSJGhWGuRgQAiSkUQTAS1',
  mapboxAerial:
    'https://api.mapbox.com/styles/v1/openaerialmap/ciyx28hy800362rto0u9x10fv/tiles/256/{z}/{x}/{y}?access_token=pk.eyJ1IjoiamhyaWIiLCJhIjoiY2t1bGR0aW1kMDhsczJ1dGhwMWRzdTQ2MCJ9.hlTq6_yVzr8fTTSWp1wO7w',
};

type AerialYears = keyof typeof aerialYears;
type YearUrls = typeof aerialYears[AerialYears];

const aerialTileLayer = (year: YearUrls = aerialYears.cuzk2023) =>
  new TileLayer({
    // https://wiki.openstreetmap.org/wiki/Slippy_map_tilenames#Tile_servers
    data: [
      // 'https://mapserver.mapy.cz/army2-m/{z}-{x}-{y}',
      // 'https://mapserver.mapy.cz/ophoto1618-m/{z}-{x}-{y}',
      // 'https://tiles.arcanum.com/mercator/secondsurvey-habsburg/bohemia/{z}/{x}/{y}',
      year,
    ],
    id: year,
    // Since these OSM tiles support HTTP/2, we can make many concurrent requests
    // and we aren't limited by the browser to a certain number per domain.
    loadOptions: {
      mimeType:
        year === aerialYears.touristSR ? 'image/png' : 'image/jpeg',
      fetch: {
        ...([
          aerialYears.mapy2018,
          aerialYears.mapy2015,
          aerialYears.mapy2003,
        ].includes(year)
          ? { mode: 'cors' }
          : {}),
      },
    },
    maxRequests: 17,
    pickable: true,
    highlightColor: [60, 60, 60, 40],
    // https://wiki.openstreetmap.org/wiki/Zoom_levels
    minZoom: 0,
    maxZoom: 19,
    // maxZoom: 18,
    tileSize: 256,
    opacity: 1,
    renderSubLayers: renderBitmapTileSubLayer,
  });

export { aerialTileLayer };
